module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                    Остались вопросы? "), _c('br'), _vm._v("\n                    Свяжитесь с нами, сделаем все что в наших силах\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 animateblock btt speed-1"
  }, [_c('form', {
    staticClass: "contact-form"
  }, [_c('div', {
    staticClass: "contact-form-box form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Имя"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-box form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact-form-box msg form-group"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": "Сообщение"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        Отправить\n                    ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b63901e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Contacts.vue
// module id = 1231
// module chunks = 1